// const hero = {
//   setting() {
//     let cells = [],
//       currentDensity = 0.4;

//     const toHex = (str) => {
//       return str
//         .split('')
//         .map(c => c.charCodeAt(0).toString(16).toUpperCase())
//         .join(' ');
//     };

//     const toBinary = (str) => {
//       return str
//         .split('')
//         .map(c => c.charCodeAt(0).toString(2).padStart(8, '0'))
//         .join(' ');
//     };

//     function getDynamicTexts() {
//       const texts = [];
//       const now = new Date();

//       // 1. Timing & Real-Time Data
//       texts.push(`UNIX_MS: ${Date.now()}`);
//       texts.push(`LOCAL_TIME: ${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`);
//       texts.push(`NAV_START: ${Math.floor(performance.now())}MS`);

//       // 2. Hardware & Performance
//       if (navigator.hardwareConcurrency) {
//         texts.push(`LOGICAL_PROCESSORS: ${navigator.hardwareConcurrency}`);
//       }
//       if (navigator.deviceMemory) {
//         texts.push(`RAM_ESTIMATE: ${navigator.deviceMemory}GB`);
//       }
//       if (performance.memory) {
//         texts.push(`JS_HEAP_LIMIT: ${Math.round(performance.memory.jsHeapSizeLimit / 1048576)}MB`);
//       }

//       // 3. Graphics & Display
//       texts.push(`VIEWPORT: ${window.innerWidth}X${window.innerHeight}`);
//       texts.push(`SCREEN_RES: ${window.screen.width}X${window.screen.height}`);
//       texts.push(`DPR: ${window.devicePixelRatio.toFixed(1)}X`);
//       texts.push(`COLOR_DEPTH: ${window.screen.colorDepth}BIT`);

//       const canvas = document.createElement("canvas");
//       const gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
//       if (gl) {
//         const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
//         if (debugInfo) {
//           const renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
//           if (renderer) texts.push(`GPU: ${renderer.split("/").pop().trim().toUpperCase()}`);
//         }
//         texts.push(`MAX_TEXTURE_SIZE: ${gl.getParameter(gl.MAX_TEXTURE_SIZE)}PX`);
//       }

//       // 4. Network & Connectivity
//       const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
//       if (conn) {
//         if (conn.effectiveType) texts.push(`NET_TYPE: ${conn.effectiveType.toUpperCase()}`);
//         if (conn.downlink) texts.push(`DOWNLINK: ${conn.downlink}MBPS`);
//         if (conn.rtt) texts.push(`RTT: ${conn.rtt}MS`);
//       }
//       if (navigator.onLine !== undefined) {
//         texts.push(`ONLINE_STATUS: ${navigator.onLine.toString().toUpperCase()}`);
//       }

//       // 5. Browser, OS & Privacy
//       if (navigator.language) texts.push(`LANG: ${navigator.language.toUpperCase()}`);
//       if (navigator.platform) texts.push(`PLATFORM: ${navigator.platform.toUpperCase()}`);

//       texts.push(`DO_NOT_TRACK: ${navigator.doNotTrack === "1" ? "ENABLED" : "DISABLED"}`);

//       if (navigator.storage?.persist) {
//         texts.push(`PERSISTENT_STORAGE: SUPPORTED`);
//       }

//       // 6. User Preferences
//       const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
//       texts.push(`PREFERS_DARK_MODE: ${prefersDark.toString().toUpperCase()}`);

//       return texts;
//     }

//     // function getDynamicTexts() {
//     //   const texts = [];
//     //   const now = new Date();

//     //   // 1. Data e Tempo Reale
//     //   texts.push(`UNIX_MS: ${Date.now()}`);
//     //   texts.push(`LOCAL_TIME: ${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`);

//     //   // 2. Hardware & Performance
//     //   if (navigator.hardwareConcurrency) {
//     //     texts.push(`CPU_CORES: ${navigator.hardwareConcurrency}`);
//     //   }
//     //   if (navigator.deviceMemory) {
//     //     texts.push(`RAM_ESTIMATE: ${navigator.deviceMemory}GB`);
//     //   }

//     //   // 3. Grafica e Schermo (Valori Reali)
//     //   texts.push(`VIEWPORT: ${window.innerWidth}X${window.innerHeight}`);
//     //   texts.push(`SCREEN_RES: ${window.screen.width}X${window.screen.height}`);
//     //   texts.push(`DPR: ${window.devicePixelRatio.toFixed(1)}X`);

//     //   // 4. GPU Introspection (Senza valori fittizi)
//     //   const canvas = document.createElement("canvas");
//     //   const gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
//     //   if (gl) {
//     //     const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
//     //     if (debugInfo) {
//     //       const renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
//     //       if (renderer) texts.push(`GPU: ${renderer.split("/").pop().trim().toUpperCase()}`);
//     //     }
//     //   }

//     //   // 5. Network & Connection (Se supportato)
//     //   const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
//     //   if (conn) {
//     //     if (conn.effectiveType) texts.push(`NET_TYPE: ${conn.effectiveType.toUpperCase()}`);
//     //     if (conn.downlink) texts.push(`DOWNLINK: ${conn.downlink}MBPS`);
//     //   }

//     //   // 6. Browser & OS (Parsing reale)
//     //   if (navigator.language) texts.push(`LANG: ${navigator.language.toUpperCase()}`);

//     //   return texts;
//     // }

//     // function getDynamicTexts() {
//     //   const now = new Date();
//     //   const months = [
//     //     "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE",
//     //     "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER",
//     //   ];
//     //   return [
//     //     `YEAR: ${now.getFullYear()}`,
//     //     `MONTH: ${months[now.getMonth()]}`,
//     //     `SECOND: ${now.getSeconds()}`,
//     //     `DAY: ${now.getDate()}`,
//     //     `CPU CORES: ${navigator.hardwareConcurrency || "U/N"}`,
//     //     `MEMORY: ${navigator.deviceMemory || "U/N"}GB`,
//     //     `WINDOW WIDTH: ${window.innerWidth}PX`,
//     //     `PLATFORM: ${navigator.platform.toUpperCase()}`,
//     //     `BROWSER: ${navigator.userAgent.split(" ")[0]}`,
//     //     `LANGUAGE: ${navigator.language.toUpperCase()}`,
//     //   ];
//     // }

//     function createCell(container, depth) {
//       const div = document.createElement("div");
//       div.className = "cell";

//       // --- AGGIUNTA LOGICA HOVER ---
//       div.addEventListener("mouseenter", () => div.classList.add("hovered"));
//       div.addEventListener("mouseleave", () => div.classList.remove("hovered"));
//       // -----------------------------

//       // Logica di suddivisione ricorsiva della griglia
//       if (depth < 5 && Math.random() > currentDensity) {
//         div.style.display = "grid";
//         const isVertical = Math.random() > 0.5;
//         const ratio = `${Math.floor(Math.random() * 5) + 1}fr ${Math.floor(Math.random() * 5) + 1
//           }fr`;
//         div.style.gridTemplateColumns = isVertical ? ratio : "1fr";
//         div.style.gridTemplateRows = isVertical ? "1fr" : ratio;
//         for (let i = 0; i < 2; i++) createCell(div, depth + 1);
//       } else {
//         // Creazione del contenuto testuale animato
//         const content = document.createElement("div");
//         content.className = "content";

//         const texts = getDynamicTexts();
//         let txt = texts[Math.floor(Math.random() * texts.length)];

//         // LOGICA GLITCH/OFFUSCAMENTO
//         const rand = Math.random();
//         if (rand > 0.9) {
//           txt = `0x ${toHex(txt.substring(0, 10))}...`; // Esadecimale parziale
//         } else if (rand > 0.8 && rand < 0.9) {
//           txt = toBinary(txt.substring(0, 5)); // Binario parziale
//         }

//         const isHorizontal = Math.random() > 0.5;

//         content.innerText = isHorizontal
//           ? `${txt} — `.repeat(20)
//           : `${txt}\n`.repeat(60);

//         if (isHorizontal) content.style.whiteSpace = "nowrap";

//         const sizes = ["40px", "18px", "9px", "5px", "3px"];
//         content.style.fontSize = sizes[depth] || "2.5px";
//         div.appendChild(content);

//         cells.push({
//           el: div,
//           depth,
//           scrollPos: 0,
//           speed: 0.2 + Math.random() * 1.2,
//           isHorizontal,
//         });
//       }
//       container.appendChild(div);
//     }

//     function updateGridStructure() {
//       const grid = document.getElementById("app");
//       if (!grid) return;

//       grid.innerHTML = "";
//       cells = [];

//       // Variazione casuale della densità ad ogni aggiornamento
//       const change = (Math.random() - 0.5) * 0.4;
//       currentDensity = Math.max(0.1, Math.min(0.8, currentDensity + change));

//       for (let i = 0; i < 16; i++) createCell(grid, 0);
//     }

//     function animate() {
//       cells.forEach((c) => {
//         c.scrollPos -= c.speed;
//         const content = c.el.querySelector(".content");
//         if (content) {
//           if (Math.abs(c.scrollPos) > 150) c.scrollPos = 0;
//           content.style.transform = c.isHorizontal
//             ? `translateX(${c.scrollPos}px)`
//             : `translateY(${c.scrollPos}px)`;
//         }
//       });
//       requestAnimationFrame(animate);
//     }

//     // Inizializzazione visiva
//     animate();
//     updateGridStructure();

//     // Aggiorna la struttura periodicamente (opzionale, simula il cambio accordo)
//     setInterval(updateGridStructure, 8000);
//   },

//   init() {
//     this.setting();
//   },
// };

// export default hero;





const hero = {
  setting() {
    let cells = [];
    let currentDensity = 0.4;
    const grid = document.getElementById("app");

    // 1. MEMOIZATION & CACHING
    // Calcoliamo i dati statici/costosi UNA SOLA VOLTA, non a ogni cella.
    const getStaticHardwareData = (() => {
      const data = [];
      if (navigator.hardwareConcurrency) data.push(`LOGICAL_PROCESSORS: ${navigator.hardwareConcurrency}`);
      if (navigator.deviceMemory) data.push(`RAM_ESTIMATE: ${navigator.deviceMemory}GB`);
      if (performance.memory) data.push(`JS_HEAP_LIMIT: ${Math.round(performance.memory.jsHeapSizeLimit / 1e6)}MB`);

      const canvas = document.createElement("canvas");
      const gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
      if (gl) {
        const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
        if (debugInfo) {
          const renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
          if (renderer) data.push(`GPU: ${renderer.split("/").pop().trim().toUpperCase()}`);
        }
        data.push(`MAX_TEXTURE_SIZE: ${gl.getParameter(gl.MAX_TEXTURE_SIZE)}PX`);
      }
      return data;
    })();

    const toHex = (str) => Array.from(str).map(c => c.charCodeAt(0).toString(16).toUpperCase()).join(' ');
    const toBinary = (str) => Array.from(str).map(c => c.charCodeAt(0).toString(2).padStart(8, '0')).join(' ');

    function getDynamicTexts() {
      const now = new Date();
      const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

      const dynamic = [
        `UNIX_MS: ${Date.now()}`,
        `LOCAL_TIME: ${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`,
        `VIEWPORT: ${window.innerWidth}X${window.innerHeight}`,
        `DPR: ${window.devicePixelRatio.toFixed(1)}X`,
        `ONLINE_STATUS: ${navigator.onLine ? "TRUE" : "FALSE"}`,
        `PREFERS_DARK_MODE: ${window.matchMedia("(prefers-color-scheme: dark)").matches.toString().toUpperCase()}`
      ];

      if (conn?.effectiveType) dynamic.push(`NET_TYPE: ${conn.effectiveType.toUpperCase()}`);

      return [...dynamic, ...getStaticHardwareData];
    }

    // 2. RECURSIVE FRAGMENT CREATION
    // Usiamo DocumentFragment per minimizzare i reflow durante la creazione
    function createCell(container, depth, fragment) {
      const div = document.createElement("div");
      div.className = "cell";
      div.setAttribute("aria-hidden", "true"); // Ignorato dagli screen reader
      div.setAttribute("role", "presentation"); // Definito come puramente estetico

      // Passive listeners per performance migliori su scroll/touch
      div.addEventListener("mouseenter", () => div.classList.add("hovered"), { passive: true });
      div.addEventListener("mouseleave", () => div.classList.remove("hovered"), { passive: true });

      if (depth < 5 && Math.random() > currentDensity) {
        div.style.display = "grid";
        const isVertical = Math.random() > 0.5;
        const ratio = `${Math.floor(Math.random() * 5) + 1}fr ${Math.floor(Math.random() * 5) + 1}fr`;
        div.style.gridTemplateColumns = isVertical ? ratio : "1fr";
        div.style.gridTemplateRows = isVertical ? "1fr" : ratio;

        for (let i = 0; i < 2; i++) createCell(div, depth + 1, null);
      } else {
        const content = document.createElement("div");
        content.className = "content";

        const texts = getDynamicTexts();
        let txt = texts[Math.floor(Math.random() * texts.length)];

        const rand = Math.random();
        if (rand > 0.9) txt = `0x ${toHex(txt.substring(0, 10))}...`;
        else if (rand > 0.8) txt = toBinary(txt.substring(0, 5));

        const isHorizontal = Math.random() > 0.5;
        content.innerText = isHorizontal ? `${txt} — `.repeat(15) : `${txt}\n`.repeat(40);
        if (isHorizontal) content.style.whiteSpace = "nowrap";

        const sizes = ["40px", "18px", "9px", "5px", "3px"];
        content.style.fontSize = sizes[depth] || "2.5px";

        // 3. WILL-CHANGE OPTIMIZATION
        // Suggeriamo al browser di promuovere l'elemento a un nuovo layer composito
        content.style.willChange = "transform";

        div.appendChild(content);

        cells.push({
          style: content.style, // Cache del riferimento allo style per l'animazione
          scrollPos: 0,
          speed: 0.2 + Math.random() * 1.2,
          isHorizontal,
        });
      }

      if (fragment) fragment.appendChild(div);
      else container.appendChild(div);
    }

    function updateGridStructure() {
      if (!grid) return;

      cells = [];
      const fragment = document.createDocumentFragment();

      const change = (Math.random() - 0.5) * 0.4;
      currentDensity = Math.max(0.1, Math.min(0.8, currentDensity + change));

      for (let i = 0; i < 16; i++) createCell(grid, 0, fragment);

      // Sostituzione atomica del DOM
      grid.innerHTML = "";
      grid.appendChild(fragment);
    }

    // 4. TRANSFORM-ONLY ANIMATION
    // Evitiamo querySelector dentro il loop a 60fps
    function animate() {
      for (let i = 0, len = cells.length; i < len; i++) {
        const c = cells[i];
        c.scrollPos -= c.speed;
        if (c.scrollPos < -150) c.scrollPos = 0;

        // Uso dei template literals per minimizzare le allocazioni di stringhe
        c.style.transform = c.isHorizontal
          ? `translateX(${c.scrollPos}px)`
          : `translateY(${c.scrollPos}px)`;
      }
      requestAnimationFrame(animate);
    }

    animate();
    updateGridStructure();
    setInterval(updateGridStructure, 8000);
  },

  init() {
    this.setting();
  },
};

export default hero;